import { ShoppingProcessType } from "InitialData/constant";
import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useRef, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import reciveImg from "resources/img/puffu/reviceImg.png";
import reciveImg2 from "resources/img/puffu/reciveImg2.png";
import activeOutlet from "resources/img/puffu/activeOutlet.png";
import inActiveOutlet from "resources/img/puffu/inActiveOutlet.png";
import { OutletContext } from "routes/front/main/WebSocketContainer";
import thankyouSound from "resources/music/two/audio_2_감사합니다__결제가_완료되었습니다_.mp3";
import number1Sound from "resources/music/two/1번.mp3";
import number2Sound from "resources/music/two/2번.mp3";
import number3Sound from "resources/music/two/3번.mp3";
import number4Sound from "resources/music/two/4번.mp3";
import number5Sound from "resources/music/two/5번.mp3";
import number6Sound from "resources/music/two/6번.mp3";
import pleaseReceiveSound from "resources/music/two/pleaseReceive.mp3";
import styles from "./HorizontalReceiveItemStep2.module.css";
import { useAudioQueue } from 'shared/hooks/useAudioQueue';
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { getDeviceCode } from "shared/utils/nativeBridge";


function HorizontalReceiveItemStep2() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setViewData } = useOutletContext();
  const { sendMessage, activeOutlets, notifyRailCompleted } = useContext(OutletContext);
  const dispatch = useDispatch();

  // Redux에서 필수 전역 상태만 가져오기
  const {
    isRailActive,
    deviceCode,
    requestDeviceCode,
    historyActiveOutlets
  } = useSelector((state) => ({
    isRailActive: state.history.isRailActive,
    deviceCode: state.history.deviceCode,
    requestDeviceCode: state.history.requestDeviceCode || state.history.deviceCode,
    historyActiveOutlets: state.history.activeOutlets || []
  }));

  // 컴포넌트 상태 정의
  const [status, setStatus] = useState('WAITING');
  const [isMyRequest, setIsMyRequest] = useState(false);
  const [processed, setProcessed] = useState(false);
  const [audioReady, setAudioReady] = useState(false);

  // 현재 주문에 대한 고유 키 생성 - 컴포넌트 상태로 관리
  const orderKey = useRef(`order_${Date.now()}`).current;

  // 타이머 ref
  const statusCheckTimer = useRef(null);
  const audioDelayTimerRef = useRef(null);
  const homeNavigationTimerRef = useRef(null);

  // 현재 기기 코드 가져오기
  const currentDeviceCode = getDeviceCode();

  // 컴포넌트 마운트/언마운트 감지 용도
  const componentMountedRef = useRef(true);

  // 오디오 관련 상태 및 함수
  const [audioPathMap, setAudioPathMap] = useState({});
  const {
    playAudioQueue,
    stopAudio,
    isPlaying,
    currentIndex,
    totalCount
  } = useAudioQueue([]);

  // 오디오 파일 경로 초기화
  useEffect(() => {
    // 경로 맵 생성
    const paths = {
      'outlet_1': number1Sound,
      'outlet_2': number2Sound,
      'outlet_3': number3Sound,
      'outlet_4': number4Sound,
      'outlet_5': number5Sound,
      'outlet_6': number6Sound,
      'pleaseReceive': pleaseReceiveSound,
      'thankyou': thankyouSound
    };

    setAudioPathMap(paths);
    console.log("오디오 경로 초기화 완료:", paths);
    setAudioReady(true);
  }, []);

  // 초기화 및 정리
  useEffect(() => {
    // 마운트 시
    componentMountedRef.current = true;
    console.log("HorizontalReceiveItemStep2 컴포넌트 마운트");

    // 이전 상태 초기화는 필요시에만
    if (!processed) {
      dispatch(HistoryReducer.actions.resetOutletState());
      stopAudio();
    }

    // 컴포넌트 마운트 시점에 내 요청인지 확인 및 설정
    if (requestDeviceCode === currentDeviceCode) {
      setIsMyRequest(true);
      console.log("내 디바이스가 요청한 주문입니다.");
    } else if (requestDeviceCode && requestDeviceCode !== currentDeviceCode) {
      setIsMyRequest(false);
      console.log("다른 디바이스가 요청한 주문입니다:", requestDeviceCode);
    }

    // 뷰 데이터 초기화
    const initData = {
      title: "",
      footterButtonText: "",
      currentProcess: ShoppingProcessType.ORDER_COMPLETE,
      totalCount: 0,
      selectedCount: 0,
      priceSum: 0,
      vat: 0,
      deliveryFee: 0,
      discountSum: 0,
      totalAmount: 0,
      onDeleteSelectedProductsClick: () => { },
      onSubmitButtonClick: () => { },
      detailYn: false,
      detailProduct: null
    };
    setViewData(initData);

    // 장바구니 초기화 메시지 전송
    if (currentDeviceCode) {
      console.log("장바구니 초기화 메시지 전송");
      sendMessage({
        code: "clearCartProducts",
        roomId: id,
        deviceCode: currentDeviceCode
      });
    }

    return () => {
      // 언마운트 표시
      componentMountedRef.current = false;
      console.log("HorizontalReceiveItemStep2 컴포넌트 언마운트");

      // 타이머 정리
      if (statusCheckTimer.current) {
        clearTimeout(statusCheckTimer.current);
        statusCheckTimer.current = null;
      }

      if (audioDelayTimerRef.current) {
        clearTimeout(audioDelayTimerRef.current);
        audioDelayTimerRef.current = null;
      }

      // 홈 네비게이션 타이머는 여기서 정리하지 않음 - 별도 useEffect에서 처리

      // 오디오 정지
      stopAudio();
      console.log("언마운트 시 오디오 강제 중지");
    };
  }, [id, setViewData, sendMessage, currentDeviceCode, requestDeviceCode, stopAudio, processed, dispatch]);

  // activeOutlets 변경 감지 및 Redux 상태 업데이트
  useEffect(() => {
    if (activeOutlets && activeOutlets.length > 0) {
      console.log("activeOutlets 변경됨:", activeOutlets);

      // Redux 상태 업데이트 - 현재 배출구 정보와 저장된 정보를 합쳐서 저장
      dispatch(HistoryReducer.actions.setActiveOutlets(activeOutlets));
    }
  }, [activeOutlets, dispatch]);

  // 완료 시 오디오 재생 함수
  const playAudio = async () => {
    // isPlaying 체크로 변경 (audioPlayed 대신)
    if (isPlaying || !audioReady) {
      console.log("오디오 이미 재생 중이거나 준비되지 않음:", { isPlaying, audioReady });
      return;
    }

    try {
      // 현재 활성화된 배출구 사용
      const currentActiveOutlets = historyActiveOutlets.length > 0 ? historyActiveOutlets : activeOutlets;

      console.log("playAudio 함수 호출됨, 현재 사용할 activeOutlets:", currentActiveOutlets);

      if (Object.keys(audioPathMap).length === 0) {
        console.warn("오디오 경로가 아직 초기화되지 않았습니다");
        return;
      }

      const audioFiles = [];

      // 활성화된 배출구가 있는 경우
      if (currentActiveOutlets && currentActiveOutlets.length > 0) {
        console.log("활성 배출구 감지됨:", currentActiveOutlets);
        // 감사합니다 메시지 추가
        audioFiles.push(audioPathMap.thankyou);

        // 정렬된 배출구 번호 목록
        const sortedOutlets = [...currentActiveOutlets].sort((a, b) => a - b);
        console.log("정렬된 배출구:", sortedOutlets);

        // 각 배출구 번호 안내 오디오 추가
        sortedOutlets.forEach(outletNumber => {
          const key = `outlet_${outletNumber}`;
          if (audioPathMap[key]) {
            audioFiles.push(audioPathMap[key]);
            console.log(`배출구 ${outletNumber}번 오디오 추가:`, audioPathMap[key]);
          } else {
            console.warn(`배출구 ${outletNumber}번에 대한 오디오 파일이 없습니다`);
          }
        });

        // "물건을 가져가세요" 안내 메시지 추가
        audioFiles.push(audioPathMap.pleaseReceive);
        console.log("안내 메시지 오디오 추가:", audioPathMap.pleaseReceive);
      } else {
        // 활성 배출구가 없는 경우 감사 메시지만 재생
        console.log("활성 배출구 없음, 감사 메시지만 재생");
        audioFiles.push(audioPathMap.thankyou);
      }

      console.log('오디오 큐 재생 시작, 파일 개수:', audioFiles.length);

      // 오디오 큐 재생
      if (audioFiles.length > 0) {
        try {
          // playAudioQueue 호출 - 배열 전달
          playAudioQueue(audioFiles);
          console.log('오디오 큐 재생 시작됨, 완료는 자동 처리됨');
        } catch (audioError) {
          console.error('오디오 재생 시작 오류:', audioError);
        }
      } else {
        console.warn('재생할 오디오 파일이 없습니다');
      }
    } catch (error) {
      console.error('오디오 재생 준비 중 오류:', error);
    }
  };


  // 레일 상태 변경 감지 로직
  useEffect(() => {
    if (currentDeviceCode && !processed) {
      console.log("Rail 상태 업데이트:", {
        isRailActive,
        deviceCode,
        requestDeviceCode,
        currentDeviceCode,
        status
      });

      // 이미 처리 완료된 경우 추가 처리 방지
      if (processed) {
        console.log("이미 처리 완료됨, 추가 상태 변경 무시");
        return;
      }

      // 레일이 활성화된 경우
      if (isRailActive) {
        // 내 디바이스가 요청자인 경우
        if (requestDeviceCode === currentDeviceCode) {
          console.log("내가 요청한 배출 작업 진행 중");
          if (status !== 'WAITING_CURRENT') {
            console.log(`상태 변경: ${status} -> WAITING_CURRENT`);
            setStatus('WAITING_CURRENT');
            setIsMyRequest(true);
          }
        }
        // 다른 디바이스가 요청자인 경우
        else if (requestDeviceCode && requestDeviceCode !== currentDeviceCode) {
          console.log("다른 디바이스가 요청한 배출 작업 진행 중:", requestDeviceCode);
          if (status !== 'WAITING_OTHER') {
            console.log(`상태 변경: ${status} -> WAITING_OTHER`);
            setStatus('WAITING_OTHER');
            setIsMyRequest(false);
          }
        }
      }
      // 레일이 비활성화된 경우
      else {
        console.log("레일 비활성화됨");

        // COMPLETED 상태면 추가 처리 방지
        if (status === 'COMPLETED') {
          console.log("레일 비활성화: 완료 트리거가 이미 발생함, 추가 처리 없음");
          return;
        }

        // 내 요청이거나 디바이스 코드가 일치하는 경우 완료 처리
        if (isMyRequest || (deviceCode === currentDeviceCode)) {
          console.log("내 요청이 완료됨");
          completeProcess();
        }
        // 다른 디바이스 요청이 완료된 경우
        else if (status === 'WAITING_OTHER') {
          console.log("다른 디바이스 요청이 완료됨");

          // 다른 디바이스의 요청이 완료된 후 자신의 요청이 큐에서 나올 수 있는지 확인
          if (statusCheckTimer.current) {
            clearTimeout(statusCheckTimer.current);
          }

          statusCheckTimer.current = setTimeout(() => {
            if (!componentMountedRef.current) return;

            console.log("지연 후 상태 확인:", {
              isRailActive,
              deviceCode,
              requestDeviceCode,
              currentDeviceCode
            });

            // 현재 디바이스가 큐의 다음 항목이 될 수 있음
            if (requestDeviceCode === currentDeviceCode) {
              console.log("내 요청이 큐에서 활성화됨");
              setIsMyRequest(true);
              setStatus('WAITING_CURRENT');
            }
          }, 300);
        }
      }
    }
  }, [isRailActive, deviceCode, requestDeviceCode, currentDeviceCode, status, processed, isMyRequest]);

  // railComplete 이벤트 처리
  useEffect(() => {
    // 함수 정의
    const handleRailCompletion = (event) => {
      if (!componentMountedRef.current) return;

      try {
        const data = event.detail;
        console.log("레일 완료 이벤트 수신:", data);

        // 이미 처리 완료된 경우 무시
        if (processed) {
          console.log("이미 처리 완료됨, 이벤트 무시");
          return;
        }

        const completionDeviceCode = data.deviceCode;
        const requestingDeviceCode = data.requestDeviceCode || completionDeviceCode;
        const eventActiveOutlets = data.activeOutlets || [];

        console.log("이벤트에서 받은 활성 배출구:", eventActiveOutlets);

        // 이벤트에서 받은 배출구 정보가 있으면 Redux 상태 업데이트
        if (eventActiveOutlets && eventActiveOutlets.length > 0) {
          dispatch(HistoryReducer.actions.setActiveOutlets(eventActiveOutlets));
        }

        // 내 디바이스인 경우 완료 처리
        if (completionDeviceCode === currentDeviceCode) {
          console.log("내 디바이스 작업 완료 확인");

          // 지연된 상태 변경 취소
          if (statusCheckTimer.current) {
            clearTimeout(statusCheckTimer.current);
            statusCheckTimer.current = null;
          }

          completeProcess();
        }
      } catch (e) {
        console.error("이벤트 처리 오류:", e);
      }
    };

    // 커스텀 이벤트 리스너 등록
    window.addEventListener('railComplete', handleRailCompletion);

    // 정리 함수
    return () => {
      window.removeEventListener('railComplete', handleRailCompletion);
    };
  }, [currentDeviceCode, processed, dispatch]);

  // completeProcess 함수 - 완료 처리
  const completeProcess = () => {
    console.log(`완료 처리 시작 - 디바이스: ${currentDeviceCode} 상태: ${status}`);

    // 이미 처리 완료 또는 완료 상태면 중복 처리 방지
    if (processed || status === 'COMPLETED') {
      console.log("이미 완료 상태입니다");
      return;
    }

    // 처리 완료 표시 설정
    setProcessed(true);

    // 상태를 COMPLETED로 설정
    console.log(`상태 변경: ${status} -> COMPLETED`);
    setStatus('COMPLETED');

    // 지연된 오디오 재생 - 기존 타이머 취소 후 새 타이머 설정
    if (audioDelayTimerRef.current) {
      clearTimeout(audioDelayTimerRef.current);
      audioDelayTimerRef.current = null;
    }

    // 오디오가 이미 재생 중인지 확인
    if (isPlaying) {
      console.log("오디오가 이미 재생 중입니다, 재생 건너뜀");
    } else {
      console.log("오디오 재생 타이머 설정, 2초 후 재생 예정");
      audioDelayTimerRef.current = setTimeout(() => {
        if (!componentMountedRef.current) {
          console.log("컴포넌트 언마운트됨, 오디오 재생 취소");
          return;
        }

        console.log("오디오 재생 시도 - 지연 타이머에서");
        playAudio();
        audioDelayTimerRef.current = null;
      }, 2000); // 2초로 지연 시간 늘림
    }

    // 레일 완료 알림 전송
    if (isMyRequest) {
      console.log("레일 완료 알림 전송");
      notifyRailCompleted();
    }
  };

  // 완료 상태에서 메인 화면으로 이동하는 타이머 관리
  useEffect(() => {
    if (status === 'COMPLETED') {
      console.log("COMPLETED 상태 - 10초 후 홈으로 이동 예정");

      if (homeNavigationTimerRef.current) {
        clearTimeout(homeNavigationTimerRef.current);
      }

      homeNavigationTimerRef.current = setTimeout(() => {
        if (!componentMountedRef.current) return;

        console.log("홈 화면으로 이동");
        // 홈 화면으로 이동
        navigate(`/ws/${id}/home`);
      }, 10000);

      console.log("홈 네비게이션 타이머 설정됨, ID:", homeNavigationTimerRef.current);
    }

    return () => {
      console.log("홈 네비게이션 useEffect 정리, ID:", homeNavigationTimerRef.current);

      if (homeNavigationTimerRef.current) {
        clearTimeout(homeNavigationTimerRef.current);
        homeNavigationTimerRef.current = null;
      }
    };
  }, [status, id, navigate]);

  // 배출구 렌더링 함수
  const renderOutletBoxes = () => {
    // 6개의 고정된 배출구 (3x2 그리드)
    const outletNumbers = [1, 2, 3, 4, 5, 6];

    // Redux에서 가져온 배출구 정보 사용
    const currentActiveOutlets = historyActiveOutlets.length > 0 ? historyActiveOutlets : activeOutlets;

    console.log("배출구 렌더링 - 활성 배출구:", currentActiveOutlets);

    return (
      <div className={styles.outletContainer}>
        {outletNumbers.map(number => {
          // 해당 배출구가 활성화되어 있는지 확인
          const isActive = currentActiveOutlets && currentActiveOutlets.includes(number);

          return (
            <div key={number} className={styles.outletBox}>
              {/* 헤더 - 활성/비활성 스타일 적용 */}
              <div
                className={`${styles.outletHeader} ${isActive ? styles.outletHeaderActive : styles.outletHeaderInactive}`}
              >
                {number} PICK UP BOX
              </div>

              {/* 배출구 배경 및 이미지 */}
              <div
                className={`${styles.outletBackground} ${isActive ? styles.outletBackgroundActive : styles.outletBackgroundInactive}`}
              >
                <img
                  src={isActive ? activeOutlet : inActiveOutlet}
                  alt={`배출구 ${number}`}
                  className={isActive ? styles.outletImageActive : styles.outletImageInactive}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // 메인 컨텐츠 - 수령 완료
  const MainContent = () => {
    // Redux에서 가져온 배출구 정보 사용
    const currentActiveOutlets = historyActiveOutlets.length > 0 ? historyActiveOutlets : activeOutlets;

    // 상태가 변경될 때마다 로그
    console.log("MainContent 렌더링 - 상태:", status, "활성 배출구:", currentActiveOutlets);

    return (
      <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
        <Dummy height={"35px"} />
        <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "93%", height: "auto", maxHeight: "900px", backgroundColor: "white" }}>
          <VerticalFlex gap={30}>
            <FlexChild height={"max-content"}>
              <Center>
                <P weight={700} size={32}>결제가 완료되었습니다.</P>
              </Center>
            </FlexChild>
            <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
            <FlexChild height={"max-content"}>
              <Center>
                <div style={{ paddingBottom: "5px", display: "inline-block" }}>
                  <P size={36} weight={700} letterSpacing={"0.5px"}>
                    {currentActiveOutlets && currentActiveOutlets.length > 0 ? (
                      <>
                        {currentActiveOutlets.map((outlet, index) => (
                          <span key={outlet} style={{ color: 'var(--main-color)' }}>
                            <span style={{
                              textDecoration: 'underline',
                              color: 'var(--main-color)'
                            }}>
                              {outlet}번
                            </span>
                            {index < currentActiveOutlets.length - 1 ? (
                              index === currentActiveOutlets.length - 2 ? " , " : ", "
                            ) : " "}
                          </span>
                        ))}
                        토출구에서 물건을 가져가세요!
                      </>
                    ) : (
                      "토출구에서 물건을 가져가세요!"
                    )}
                  </P>
                </div>
              </Center>
            </FlexChild>
            <FlexChild>
              {/* 배출구 그리드 렌더링 */}
              {renderOutletBoxes()}
            </FlexChild>
          </VerticalFlex>
        </div>
      </div>
    );
  };

  // 다른 키오스크 사용 중 컨텐츠
  const AnotherRailActivatedContent = () => (
    <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
      <Dummy height={"35px"} />
      <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "95.7%", height: "870px" }}>
        <VerticalFlex gap={50}>
          <FlexChild height={"max-content"}>
            <Center>
              <P weight={700} size={32}>결제가 완료되었습니다.</P>
              <Dummy height={"15px"} />
              <P weight={500} size={25}>구매해주셔서 감사합니다.</P>
            </Center>
          </FlexChild>
          <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
          <FlexChild height={"max-content"}>
            <Center>
              <P size={32} weight={700} color={"var(--main-color)"}>먼저 구매한 고객님이 물건을 수령 중이에요.</P>
              <P size={32} weight={700} color={"var(--main-color)"}>잠시만 기다려주세요.</P>
            </Center>
          </FlexChild>
          <FlexChild>
            <img src={reciveImg2} width={"700px"} alt="상품 준비중 이미지" />
          </FlexChild>
        </VerticalFlex>
      </div>
    </div>
  );

  // 현재 키오스크 사용 중 컨텐츠
  const PaymentCompleteContent = () => (
    <div style={{ alignItems: "center", display: "flex", flexDirection: "column" }}>
      <Dummy height={"35px"} />
      <div style={{ border: "1.5px solid var(--point-color)", borderRadius: "7px", position: "relative", padding: "60px 0", width: "95.7%", height: "870px" }}>
        <VerticalFlex gap={25}>
          <FlexChild height={"max-content"}>
            <Center>
              <P weight={700} size={32}>결제가 완료되었습니다.</P>
              <Dummy height={"15px"} />
              <P weight={500} size={25}>구매해주셔서 감사합니다.</P>
            </Center>
          </FlexChild>
          <FlexChild height={"1px"} backgroundColor={"rgba(225, 225, 225, 1)"} width={"90%"} />
          <FlexChild height={"max-content"}>
            <Center>
              <P size={32} weight={700} color={"var(--main-color)"}>푸푸가 고객님의 물건을 준비중이에요.</P>
              <P size={32} weight={700} color={"var(--main-color)"}>잠시만 기다려주세요.</P>
            </Center>
          </FlexChild>
          <FlexChild>
            <img src={reciveImg2} width={"700px"} alt="상품 준비중 이미지" />
          </FlexChild>
        </VerticalFlex>
      </div>
    </div>
  );

  // 상태에 따른 렌더링
  const renderContent = () => {
    switch (status) {
      case 'WAITING_OTHER':
        return <AnotherRailActivatedContent />;
      case 'WAITING_CURRENT':
        return <PaymentCompleteContent />;
      case 'COMPLETED':
        return <MainContent />;
      default:
        // 초기 WAITING 상태에서는 아무것도 표시하지 않음
        return <div style={{ display: 'none' }}></div>;
    }
  };

  return renderContent();
}

export default HorizontalReceiveItemStep2;